import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";
import RolePicker from "../RolePicker";

export default function BoostingSection({
  channels,
  roles,
  customBoosterRoles,
  setCustomBoosterRoles,
  boostRoleId,
  setBoostRoleId,
  boostChannel,
  setBoostChannel,
  boostMessage,
  setBoostMessage,
  siteSupporterPerksEnabled,
  setSiteSupporterPerksEnabled,
  customRoleAnchorId,
  setCustomRoleAnchorId,
  customRolePlacement,
  setCustomRolePlacement,
}) {
  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Announce boosts, give a role to people who boost this server, and
        optionally let them create a custom booster role. Nocturne Patrons can
        already create custom roles everywhere. Also editable via{" "}
        <code>/settings</code> → Boosting.
      </p>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          marginBottom: "12px",
        }}
      >
        <input
          type="checkbox"
          checked={siteSupporterPerksEnabled}
          onChange={(e) => setSiteSupporterPerksEnabled(e.target.checked)}
          style={{ accentColor: "#b85c6e" }}
        />
        <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
          ALLOW SERVER-IMPACTING SITE SUPPORTER FEATURES
        </span>
      </label>
      <p
        className="help-text"
        style={{
          fontSize: "0.75rem",
          marginTop: "-4px",
          marginBottom: "20px",
          opacity: 0.6,
        }}
      >
        When on: Benefactor custom triggers, Benefactor announce, and automatic
        Patron giveaway +1 work here. Personal donor perks (
        <code>/patron</code> fun, reminds, AFK extras, confession colors,
        profile cosmetics) always work for donors in every server. Defaults on.
      </p>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        <input
          type="checkbox"
          checked={customBoosterRoles}
          onChange={(e) => setCustomBoosterRoles(e.target.checked)}
          style={{ accentColor: "#b85c6e" }}
        />
        <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
          ALLOW CUSTOM BOOSTER ROLES FOR THIS SERVER
        </span>
      </label>
      <p
        className="help-text"
        style={{
          fontSize: "0.75rem",
          marginTop: "-12px",
          marginBottom: "16px",
          opacity: 0.6,
        }}
      >
        If enabled, members who boost this server can use{" "}
        <code>/level booster role</code> here even if they do not boost Nocturne.
      </p>

      {customBoosterRoles && (
        <>
          <label className="input-label">CUSTOM ROLE ANCHOR</label>
          <RolePicker
            roles={roles}
            value={customRoleAnchorId}
            onChange={setCustomRoleAnchorId}
            emptyLabel="Default (Server Booster role)"
            placeholder="Select anchor role…"
          />
          <p
            className="help-text"
            style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
          >
            Custom booster roles are created relative to this role. Kami must sit
            above it in the role list.
          </p>

          <label className="input-label" style={{ marginTop: "15px" }}>
            PLACE CUSTOM ROLES
          </label>
          <select
            value={customRolePlacement}
            onChange={(e) => setCustomRolePlacement(e.target.value)}
            className="settings-input"
          >
            <option value="above">Above the anchor</option>
            <option value="below">Below the anchor</option>
          </select>
          <p
            className="help-text"
            style={{
              fontSize: "0.75rem",
              marginTop: "8px",
              marginBottom: "16px",
              opacity: 0.6,
            }}
          >
            Above = higher in the hierarchy (typical). Below = tucked under the
            anchor.
          </p>
        </>
      )}

      <label className="input-label">BOOST ANNOUNCEMENT CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={boostChannel}
        onChange={setBoostChannel}
        emptyLabel="None (no public boost message)"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        BOOST REWARD ROLE
      </label>
      <RolePicker
        roles={roles}
        value={boostRoleId}
        onChange={setBoostRoleId}
        emptyLabel="None"
        placeholder="Select boost reward role…"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Given when someone boosts this server and removed when the boost ends.
      </p>

      <label className="input-label" style={{ marginTop: "15px" }}>
        BOOST MESSAGE
      </label>
      <textarea
        value={boostMessage}
        onChange={(e) => setBoostMessage(e.target.value)}
        className="settings-input large-text"
        rows={4}
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Placeholders: {"{user}"} {"{userName}"} {"{server}"} {"{server.boosts}"}{" "}
        {"{server.boost_level}"}
      </p>
    </SettingsSection>
  );
}
